import {
  ChakraBox,
  ChakraFlex,
  CircularProgress,
  Counter,
  FireflyTertiaryButtonMenu,
  FireflyTertiaryButtonMenuItem,
  Text,
} from '@equip.health/ui';

const TOP_LEVEL_ID = 'users-table-action-bar';

export interface UsersTableActionBarProps {
  userCount: number;
  isDataLoading: boolean;
  sortBy: string;
  onSortByChange: (val: string) => void;
}

const sortingOptions: FireflyTertiaryButtonMenuItem[] = [
  { label: 'Name', node: 'name' },
  { label: 'Email', node: 'email' },
  { label: 'Cell phone', node: 'phone-number' },
];

const UsersTableActionBar = ({
  sortBy,
  isDataLoading,
  onSortByChange,
  userCount,
}: UsersTableActionBarProps) => (
  <ChakraFlex
    alignItems="center"
    justifyContent="space-between"
    paddingRight="30px"
  >
    <ChakraFlex alignItems="center" gap="12px">
      <Text variant="h3">Users</Text>

      {isDataLoading ? (
        <CircularProgress
          id={`${TOP_LEVEL_ID}__loader`}
          isIndeterminate
          padding="8px"
          size="30px"
        />
      ) : (
        <Counter number={userCount} />
      )}
    </ChakraFlex>
    <ChakraBox zIndex={2}>
      <FireflyTertiaryButtonMenu
        buttonId={`${TOP_LEVEL_ID}__sort-by`}
        buttonText={
          sortingOptions.find((o) => o.node === sortBy)?.label || 'Sort by'
        }
        onOptionClick={onSortByChange}
        options={sortingOptions}
      />
    </ChakraBox>
  </ChakraFlex>
);

export default UsersTableActionBar;
